//TODO: after merging all branches to master, move all common enums here

export enum MetricType {
    Percentage = 1,
    Count = 2,
    Money = 3,
}

export enum SegmentTypeEnum {
    Dynamic = 0,
    Static = 1,
    Composite = 3,
}

export enum SaveModesEnum {
    SaveAsLive = 'SaveAsLive',
    SaveAsTest = 'SaveAsTest',
    SaveAsDraft = 'SaveAsDraft',
}

export enum PageTypesEnum {
    create = 'create',
    clone = 'clone',
    edit = 'edit',
    predefined = 'predefined',
    view = 'view',
    execute = 'execute',
    convert = 'convert',
}

export enum DataTableConfigKeysEnum {
    dataTableCommunication = 'dataTableCommunication',
    dataTableCampaignCommunication = 'dataTableCampaignCommunication',
    dataTableWFCommunication = 'dataTableWFCommunication',
}

export enum LabelAppearanceEnum {
    none = 'none',
    title = 'title',
    swap = 'swap',
}

//TODO: after merging all branches to master, move all common enums here
